
<button
    type="button"
    class="btn-close btn-close-white"
    aria-label="Close"
    (click)="activeModal.dismiss()">
</button>

<div class="modal-body text-center text-white">
    <h2 class="modal-title h1 lh-sm fw-bold mb-2">
        Opt-in today to stay up to date on prizes and giveaways!
    </h2>
    <p class="mb-0">
        Your monthly newsletter will be filled with informative,
        pet friendly content for {{ petName }}.
        Your next big win could be around the corner.
    </p>
</div>
<div class="modal-footer justify-content-center border-0">
    <button 
        type="button"
        class="btn btn-lg btn-light shadow fs-3 w-100"
        (click)="activeModal.close()"
        trackClickEvent
        [eventNumber]="ClickEventNumbersEnum.Step4OptInPopupSubmit">
        Submit
    </button>
</div>
